import React from 'react'

const Success = ({ text }) => {
    return (
        <div className="succcess-container">
            <div className="success">
                {text}
            </div>
        </div>
    )
}

export default Success
